import type { ActivityType } from '../../../typings'
import type { ActivityTypeUpdated } from './typings'

export const activityTypeUpdatedActionCreator = (
  payload?: ActivityType,
): ActivityTypeUpdated => ({
  type: 'activityTypes/updated',
  payload,
})
